<label *ngIf="label" class="ptl-select__label">{{ label }}</label>
<mat-select
  class="sg-select"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [panelClass]="panelClass"
  (selectionChange)="onSelectionChange($event)"
  (blur)="onBlur()"
>
  @for (option of options; track option.value) {
    <mat-option [value]="option.value">{{ option.label }}</mat-option>
  }
</mat-select>
